import React from 'react';

import styled from 'styled-components';

import {ReactComponent as SortIcon} from 'assets/svg/arrow-bottom-long.svg';
import {colors} from 'theme';

import {Icon} from '../Icon';

export const SortingIndicator = ({
    isSorted,
    isSortedDesc,
}: {
    isSorted: boolean;
    isSortedDesc: boolean;
}) => {
    if (!isSorted) {
        return (
            <SortingIndicatorIcon
                fillColor={'#b5b5b5'}
                isSortedDesc={true}
                source={SortIcon}
                width={6}
                height={10}
                block={false}
            />
        );
    }

    return (
        <SortingIndicatorIcon
            fillColor={colors.black}
            isSortedDesc={isSortedDesc}
            source={SortIcon}
            width={6}
            height={10}
            block={false}
        />
    );
};

const SortingIndicatorIcon = styled(Icon)<{isSortedDesc: boolean}>`
    margin-left: 10px;
    vertical-align: baseline;
    transform: rotate(${(p) => (p.isSortedDesc ? '0' : '180deg')});
`;
